module.exports = __webpack_public_path__ + "img/ltkitbag-2x.8fbe0d5.jpg";